import Icon from 'components/base/Icon';
import { unselectable } from 'components/base/layout-components';
import Text from 'components/base/Text';
import React from 'react';
import { GridDropZone, GridItem } from 'react-grid-dnd';
import styled from 'styled-components';
import { DragBoxFlex, Title } from './CustomizeTableModal.sections';

const Item = styled(GridItem)`
  display: flex;
  ${unselectable()};
  cursor: pointer;
  height: 25px;
`;

const LeftBox = ({ items = [], onAdd = () => null }) => {
  return (
    <DragBoxFlex direction='column'>
      <Title
        title='Available columns'
        subtitle='Click or drag to the right to add to the table:'
      />

      <GridDropZone
        id='left'
        boxesPerRow={1}
        rowHeight={40}
        style={{ height: 400 }}
        data-cy='leftMenu'
      >
        {items.map(({ name, id }) => (
          <Item key={name}>
            <Icon
              name='add'
              color='shuttleGray'
              size='medium'
              onClick={() => onAdd(id)}
            />
            <Text pl='0.5rem' pt='0.2rem' size='large'>
              {name}
            </Text>
          </Item>
        ))}
      </GridDropZone>
    </DragBoxFlex>
  );
};

export default LeftBox;
